import React from 'react'
import iconPaste from '../svgs/icons.js'

export default function Status({ui_element_id, param_value, add, status_type}){
    let content = ''
    const classes = []
    let fill_style
    //console.log('add_param_value',param_value)

    switch (status_type) {
        default:
        case 'text':
            content = <div className="status">{param_value} {add}</div>
            break;
        case 'icon_activity':
            if (param_value == 'true') classes.push('switch-true')
            else fill_style = {filter: 'blur(1px)'}

            content = <div className={'switch ' + classes.join(' ')}>
                <div className={'icon ' + classes.join(' ')} style={fill_style}>{iconPaste(add)}</div>
            </div>
            break;
        case 'icon_status_color':
            if (param_value == 'ok') {
                classes.push('switch-ok')
                fill_style = {filter: 'blur(1px)'}
            }
            else if (param_value == 'warning') classes.push('switch-warning')
            else if (param_value == 'error') {
                classes.push('switch-error')
            }

            content = <div className={'switch ' + classes.join(' ')}>
                <div className={'icon ' + classes.join(' ')} style={fill_style}>{iconPaste(add)}</div>
            </div>
            break;
    }
    return content
}